// MobileDrawer.tsx
import * as React from "react";
import MenuIcon from "@mui/icons-material/Menu";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import {
  headerNavigationConstants,
  type NavigationItem,
} from "../../../constants/navigationConstants";
import MobileDrawerHeader from "./MobileDrawerHeader";
import {
  DrawerContnet,
  DropdownButtonTitle,
  IconButtonStyled,
  MenuDropdownItem,
  MenuList,
  SocialNetworksContent,
} from "./MobileDrawer.styled";
import Drawer from "@mui/material/Drawer";
import SocialNetworks from "../SocialNetworks/SocialNetworks";
import { AccordionSummary, AccordionDetails } from "@mui/material";

import DropdownIcon from "src/assets/icons/dropdown-icon.svg?react";
import HeaderMenuItem from "../HeaderMenu/HeaderMenuItem";
import { useLocation, useNavigate } from "react-router-dom";
import Rectangle from "../../Rectangle/Rectangle";

/**
 * Interface defining the props for the MobileDrawer component.
 */
interface MobileDrawerProps {
  /** Optional function called when a menu item is clicked. It receives the `page` (string) as an argument. */
  onMenuItemClick?: (page: string) => void;
  /** The side from which the Drawer opens. Defaults to 'left'. */
  anchor?: "left" | "right" | "top" | "bottom";
}

/**
 * Reusable component for a mobile navigation menu that displays as a side panel (MUI Drawer).
 */
const MobileDrawer = ({ anchor = "left" }: MobileDrawerProps) => {
  const [openDrawer, setOpenDrawer] = React.useState(false);

  const { pathname } = useLocation();

  const navigate = useNavigate();

  const handleOpenDrawer = () => {
    setOpenDrawer(true);
  };

  const handleCloseDrawer = (page: NavigationItem | null) => {
    setOpenDrawer(false);
    if (page !== null && page.route !== null) {
      navigate(page.route ?? "/");
    }
  };
  const [expanded, setExpanded] = React.useState<string | false>();

  const handleChange = (panel: string) => {
    setExpanded((priv) => (priv !== panel ? panel : false));
  };

  const ActiveDropdown = React.useMemo(() => {
    const dropdowns = headerNavigationConstants.filter((x) => x.dropdown);
    const items = dropdowns.map((item) => {
      const hasActiveLink = item.dropdown?.some((x) => x.route === pathname);
      return hasActiveLink ? item.title : null;
    });
    return items.find((x) => x !== null);
  }, [pathname]);

  return (
    <>
      <IconButtonStyled
        size="large"
        aria-label="open navigation drawer"
        onClick={handleOpenDrawer}
        // color="inherit"
      >
        <MenuIcon />
      </IconButtonStyled>

      <Drawer
        anchor={anchor}
        open={openDrawer}
        onClose={() => handleCloseDrawer(null)}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: "100%",
          },
        }}
      >
        <DrawerContnet sx={{ width: "100%" }} role="presentation">
          <MobileDrawerHeader
            handleOpenDrawer={() => handleCloseDrawer(null)}
          />
          <MenuList>
            {headerNavigationConstants.map(
              (page: NavigationItem, index: number) => (
                <ListItem key={index} disablePadding>
                  {!page.dropdown && (
                    <HeaderMenuItem
                      {...page}
                      pathname={window.location.pathname}
                      onClick={() => handleCloseDrawer(page)}
                    />
                  )}
                  {page.dropdown && (
                    <MenuDropdownItem
                      expanded={expanded === page.title}
                      onChange={() => handleChange(page.title)}
                    >
                      <AccordionSummary
                        aria-controls={`${page.title}-content`}
                        id={page.title}
                      >
                        <DropdownButtonTitle>
                          <span>{page.title}</span>
                          {
                            ActiveDropdown == page.title && (
                              <Rectangle width={"100%"} height={4} />
                            ) /*isActive &&*/
                          }
                        </DropdownButtonTitle>

                        <DropdownIcon />
                      </AccordionSummary>
                      <AccordionDetails>
                        <List>
                          {page.dropdown.map((item, index) => (
                            <ListItem key={index} disablePadding>
                              <ListItemButton
                                onClick={() => handleCloseDrawer(item)}
                              >
                                <ListItemText primary={item.title} />
                              </ListItemButton>
                            </ListItem>
                          ))}
                        </List>
                      </AccordionDetails>
                    </MenuDropdownItem>
                  )}
                </ListItem>
              )
            )}
          </MenuList>
          <SocialNetworksContent>
            <SocialNetworks whiteIcon />
          </SocialNetworksContent>
        </DrawerContnet>
      </Drawer>
    </>
  );
};

export default MobileDrawer;
